import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        error: {
            redirectButtonText: string;
        };
    };
};

export const messagesNL: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    step: {
        personalInfo: {
            howDoesVerifyingWorkDetails: 'Om in aanmerking te komen voor deze aanbieding, moet u (1) een medische professional zijn die momenteel een licentie en (2) lid zijn van een in aanmerking komende tak van de medische beroep. In aanmerking komende takken worden weergegeven in de Status kiezer van dit formulier.<br><br>{companyName} gebruikt SheerID, een vertrouwde partner, om te verifiëren dat u een medische professional bent. SheerID verzamelt alleen informatie die helpt bij het verifiëren van uw geschiktheid. Er kan om aanvullende informatie of documentatie worden gevraagd. ',
        },
        success: {
            verificationOnly: "SheerID zorgt alleen voor verificatie. Nu dat u bent goedgekeurd, kunt u alle vragen over de promotievoorwaarden en/of het codegebruik richten aan de klantenservice van <a href='https://www.timberland.co.uk/customer-service/contact-us.html?geoRedirect=true' target=_blank class='sid-link' >Timberland</a>.",
        },
        error: {
            redirectButtonText: 'DOORGAAN MET TIMBERLAND',
        },
    },
};
